export default __webpack_public_path__ + "static/media/1910.92b73216.png";